import React from 'react'

interface NewReleasesIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * Starburst badge with an exclamation mark (Material Icons `new_releases`): the
 * glyph mobile's pending-invitations card shows.
 */
const NewReleasesIcon: React.FC<NewReleasesIconProps> = ({
  size = 24,
  color = '#e8eaed',
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${size}px`}
      viewBox='0 0 24 24'
      width={`${size}px`}
      fill={color}
      className={className}
      aria-hidden='true'
    >
      <path d='M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z' />
    </svg>
  )
}

export default NewReleasesIcon
